<template>
  <b-modal
    id="pp-visume-modal"
    ref="modal"
    hide-header
    hide-footer
    centered
    size="xl"
    content-class="pp-visume-modal__content"
    body-class="pp-visume-modal__body"
    modal-class="pp-visume-modal"
    @shown="onShown"
    @hidden="onHidden"
  >
    <div class="pp-visume-modal__header">
      <div class="pp-visume-modal__header-text">
        <p class="pp-visume-modal__eyebrow">
          <i class="mdi mdi-video" aria-hidden="true"></i> Visume
        </p>
        <h2 class="pp-visume-modal__title">{{ candidateName }}</h2>
      </div>
      <button
        type="button"
        class="pp-visume-modal__close"
        aria-label="Close visume"
        @click="close"
      >
        <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false">
          <path fill="currentColor" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
        </svg>
      </button>
    </div>

    <div class="pp-visume-modal__stage">
      <video
        v-if="visumeUrl"
        ref="video"
        class="pp-visume-modal__video"
        controls
        playsinline
        controlsList="nodownload"
        :src="visumeUrl"
        preload="metadata"
        @click.stop
      ></video>
    </div>

    <p class="pp-visume-modal__hint">Video introduction shared on this public Hireclap profile.</p>
  </b-modal>
</template>

<script>
export default {
  name: 'PublicProfileVisumeModal',
  props: {
    candidateName: { type: String, default: '' },
    visumeUrl: { type: String, default: '' },
  },
  methods: {
    show() {
      if (!this.visumeUrl) return;
      this.$refs.modal.show();
    },
    close() {
      this.$refs.modal.hide();
    },
    onShown() {
      const video = this.$refs.video;
      if (!video) return;
      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {});
      }
    },
    onHidden() {
      const video = this.$refs.video;
      if (!video) return;
      video.pause();
      video.currentTime = 0;
    },
  },
};
</script>
